import styled from "@emotion/styled";
import { Button, Col, Empty, Input, Row, Space } from "antd";
import { useEffect, FC, SetStateAction, Dispatch, useState } from "react";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
import { Pagination } from 'antd';
import { LoadAgentContactsResponse } from "services/interface";
import AgentDataCard from "../AgentCard";
const { Search } = Input;


interface AgentListProps {
  data: LoadAgentContactsResponse | undefined;
  isLoading: boolean;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  itemsPerPage: number;
  setSearch: Dispatch<SetStateAction<string>>;
  refetch: ()=> void;
}
const AgentList:FC<AgentListProps> = ({ data, isLoading, currentPage, setCurrentPage, setSearch, itemsPerPage, refetch }) => {
  const dispatch = useAppDispatch();

  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  
  }, [isLoading]);

  const handleSearch = () => {
    setSearch(searchInput);
  };

  const handleAfterDelete = () => {
    if (currentPage > 1 && data && data.data.contacts.length <= 1) {
      setCurrentPage(currentPage - 1);
    } else {
      refetch();
    }
  };

  return (
    <>
     <WrapperAll>
      <HeadWrapper>

        <ButtonWrapper>
          <Space.Compact>
            <Input 
              style={{height:'32px',width:'100px;'}} 
              placeholder="ค้นหาชื่อ หรือ เบอร์โทรศัพท์"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
             />
            <Button type="default" onClick={handleSearch}>ค้นหา</Button>
          </Space.Compact>
        </ButtonWrapper>
        <PaginationWrapper
          current={currentPage}
          size={'small'}
          responsive={true}
          // totalBoundaryShowSizeChanger={3}
          onChange={(page) => setCurrentPage(page)}
          // total={data?.contacts?.length || 0}
          total={data?.data?.total_record}
          // defaultCurrent={3} 
          pageSize={itemsPerPage}
          // showSizeChanger={true}
        />
      </HeadWrapper>

      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >
        {data && data?.data.contacts.length > 0 ?
        <>
          { data && data?.data.contacts?.map((item) => {
            return (  
              <AgentDataCard
                key={item.id}
                data={item}
                refetch={refetch}
                handleAfterDelete={handleAfterDelete}
              />
            );
          })}
        </>
        :
          <NotFoundWrapper>
            <Empty description={"ไม่มีตัวแทน"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </NotFoundWrapper>
      }
      </Row>
    </WrapperAll>
      
    </>
  );
};

export default AgentList;
const PaginationWrapper = styled(Pagination)`
  white-space: nowrap;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const NotFoundWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;